import { devicesAdapterSelectors } from '../redux/slices/devices';
import { customersAdapterSelectors } from '../redux/slices/customers';
import { createSelector } from 'reselect';
import { getUser } from './userSelectors';
import { DEVICE_TYPES } from '../constants';

export const getAll = devicesAdapterSelectors.selectAll;

export const getDeviceById = (id) => (state) =>
  devicesAdapterSelectors.selectById(state, id);

export const currentWorkspaceDevices = createSelector(
  (state) => devicesAdapterSelectors.selectAll(state),
  (state) => state.currentWorkspace.id,
  (devices, currentWorkspace) =>
    devices.filter((device) => device.workspaceId === currentWorkspace)
);
export const selectDevicesByCustomerId = createSelector(
  (state) => devicesAdapterSelectors.selectAll(state),
  (_, customerId) => customerId,
  (devices, customerId) =>
    devices.filter((device) => device.customerId === customerId)
);

export const selectDevicesByMembershipAccess = createSelector(
  (state) => devicesAdapterSelectors.selectAll(state),
  getUser(),
  (allDevices, user) => {
    if (!user?.userRoles) return [];

    const deviceIds = new Set();

    // Collect device IDs from userRoles
    for (const userRole of user.userRoles) {
      if (userRole.customer) {
        // Add all devices with this customerId
        allDevices.forEach((device) => {
          if (device.customerId === userRole.customer.id) {
            deviceIds.add(device.id);
          }
        });
      }
      if (userRole.device?.id) {
        // Add standalone device
        deviceIds.add(userRole.device.id);
      }
    }

    return allDevices.filter((device) => deviceIds.has(device.id));
  }
);
export const selectInvitableDevicesForCustomer = createSelector(
  selectDevicesByMembershipAccess,
  (_, customerId) => customerId,
  (accessibleDevices, customerId) =>
    accessibleDevices.filter((device) => device.customerId === customerId)
);

export const getAllLastPosition = createSelector(
  currentWorkspaceDevices,
  (devices) =>
    devices.reduce((acc, device) => {
      if (device.lastDevicePosition) {
        acc.push([
          device.lastDevicePosition.latitude,
          device.lastDevicePosition.longitude,
        ]);
      }
      return acc;
    }, [])
);

export const getAllDeviceWithPosition = createSelector(
  currentWorkspaceDevices,
  (devices) =>
    devices.filter((device) => device.type.toLowerCase() !== DEVICE_TYPES.ALARM)
);

export const getDevicesWithPositionByCustomer = createSelector(
  (state) => devicesAdapterSelectors.selectAll(state),
  (_, customerId) => customerId,
  (allDevices, customerId) => {
    // If no customer selected, return empty array
    if (!customerId) {
      return [];
    }

    // Filter by selected customer
    return allDevices.filter(
      (device) =>
        device.customerId === customerId &&
        device.type.toLowerCase() !== DEVICE_TYPES.ALARM
    );
  }
);
